import {RefObject} from 'react';
import {DayOfWeekList} from '../../../graphql/generated/types';
import {DayOfWeekLogProps} from '../type';
import {DayOfWeekSection} from './DayOfWeekSection';

interface Props {
  columnIndex?: number;
  columnListRef?: RefObject<HTMLDivElement>;
  columnData: DayOfWeekList;
  logProps: DayOfWeekLogProps;
  isMobile?: boolean;
}

export const DayOfWeekColumnList = ({
  columnIndex,
  columnListRef,
  columnData,
  logProps,
  isMobile,
}: Props) => {
  return (
    <DayOfWeekSection.Column
      columnRef={columnListRef}
      className={isMobile ? 'pb-10pxr' : 'pb-40pxr'}
    >
      <DayOfWeekSection.Column.List
        listElement={columnData.list.map((item, itemIndex) => (
          <DayOfWeekSection.Column.List.Item
            key={`column-list-item-${item.id}-index:${itemIndex}`}
            item={item}
            columnIndex={columnIndex}
            cardIndex={itemIndex}
            logProps={logProps}
          />
        ))}
        bannerElement={
          columnData.banner && (
            <DayOfWeekSection.Column.List.BannerItem
              columnIndex={columnIndex}
              bannerItem={columnData.banner}
              logProps={logProps}
            />
          )
        }
      />
    </DayOfWeekSection.Column>
  );
};
